<template>
    <div id="gallery" class="flex-col">
        <h1 class="text-4xl">Galerie</h1>
        <h2 class="text-xl text-light_grey">Gallery</h2>
        <div class="images mt-12">
            <div class="row w-full md:flex">
                <div class="w-full md:w-2/3">
                    <img class="w-full" alt="In and around the apartment" src="../assets/images/out1xx.jpg"
                        title="In and around the apartment">
                </div>
                <div class="w-full md:w-1/3 flex-col">
                    <img class="h-1/2" alt="In and around the apartment" src="../assets/images/air2.jpg"
                        title="In and around the apartment">
                    <img class="h-1/2" alt="In and around the apartment" src="../assets/images/out4.jpg"
                        title="In and around the apartment">
                </div>
            </div>
            <div class="row w-full md:flex">
                <div class="w-full md:w-1/3 flex-col">
                    <img class="" alt="In and around the apartment" src="../assets/images/air7.jpg"
                        title="In and around the apartment">
                    <img class="" alt="In and around the apartment" src="../assets/images/out8.jpg"
                        title="In and around the apartment">
                </div>
                <div class="w-full md:w-2/3">
                    <img class="w-full" alt="In and around the apartment"
                        src="../assets/images/air1.jpg" title="In and around the apartment">
                </div>
            </div>
            <div class="row w-full md:flex">
                <div class="w-full md:w-1/2">
                    <img class="w-full" alt="In and around the apartment"
                        src="../assets/images/air6.jpg" title="In and around the apartment">
                </div>
                <div class="w-full md:w-1/2">
                    <img class="w-full" alt="In and around the apartment" src="../assets/images/out7.jpg"
                        title="In and around the apartment">
                </div>
            </div>
            <div class="row w-full md:flex">
                <div class="w-full md:w-2/3">
                    <img class="w-full" alt="In and around the apartment" src="../assets/images/out6.jpg"
                        title="In and around the apartment">
                </div>
                <div class="w-full md:w-1/3 flex-col">
                    <img class="h-1/2" alt="In and around the apartment" src="../assets/images/air5fertig.jpg"
                        title="In and around the apartment">
                    <img class="h-1/2" alt="In and around the apartment" src="../assets/images/out3.jpg"
                        title="In and around the apartment">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>